import BpkText, {
  TEXT_STYLES,
  TEXT_COLORS,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import reactReplacePlaceholder from 'react-replace-placeholder';

import constants from '../constants';
import withStrings from '../withStrings';

import type { QuoteLinkProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationsExplorer';

const {
  STRINGS: { FROM_PRICE, GET_PRICES },
} = constants;

const QuoteLink = ({ price, strings }: QuoteLinkProps) => (
  <BpkText
    color={TEXT_COLORS.textPrimary}
    textStyle={TEXT_STYLES.heading4}
    data-testid="quote-link"
  >
    {price
      ? reactReplacePlaceholder(strings[FROM_PRICE], { price }, '@@', '@@')
      : strings[GET_PRICES]}
  </BpkText>
);

export default withStrings(QuoteLink);
